import { useEffect, useMemo, useState } from 'react'
import { Select } from 'antd'
import listCollaborators from 'services/collaborator/listCollaborators'
import { getCollaboratorName, sortCollaborators, collaboratorMatches } from 'utils/collaborators'

// Lista da equipe carregada uma vez por sessão e compartilhada entre os seletores
let pedido = null
let carregadaEm = 0
export function carregarEquipe() {
  if (!pedido || Date.now() - carregadaEm > 5 * 60 * 1000) {
    carregadaEm = Date.now()
    pedido = listCollaborators()
      .then(({ data }) => sortCollaborators(data).filter((c) => c.email !== 'admin@gmail.com'))
      .catch((erro) => { pedido = null; throw erro })
  }
  return pedido
}
export function esquecerEquipe() { pedido = null }

export function useEquipe(fornecida) {
  const [equipe, setEquipe] = useState(Array.isArray(fornecida) ? fornecida : [])
  useEffect(() => {
    if (Array.isArray(fornecida)) { setEquipe(fornecida); return undefined }
    let ativo = true
    carregarEquipe().then((lista) => { if (ativo) setEquipe(lista) }).catch(() => {})
    return () => { ativo = false }
  }, [fornecida])
  return equipe
}

// "a,b; c|d" ou ['a', 'b'] → ['a', 'b', 'c', 'd'] (sem repetir)
export function idsDe(valor) {
  const lista = Array.isArray(valor) ? valor : String(valor ?? '').split(/[,;|]/)
  return [...new Set(lista.map((v) => String(v ?? '').trim()).filter(Boolean))]
}

// Seletor de pessoas da equipe por id. Sempre mostra o nome (nunca o id ou o e-mail):
// quem saiu da equipe aparece como "Fora da equipe". `multiplo` liga várias pessoas.
export default function SeletorEquipe({ value, onChange, multiplo = true, equipe: fornecida, placeholder, ...props }) {
  const equipe = useEquipe(fornecida)
  const selecionados = multiplo ? idsDe(value) : (value ? String(value) : undefined)

  const opcoes = useMemo(() => {
    const lista = equipe.map((c) => ({ value: String(c.id), label: getCollaboratorName(c) }))
    const conhecidos = new Set(lista.map((o) => o.value))
    const fora = (multiplo ? selecionados : [selecionados].filter(Boolean)).filter((id) => equipe.length && !conhecidos.has(id))
    return [...lista, ...fora.map((id) => ({ value: id, label: 'Fora da equipe' }))]
  }, [equipe, multiplo, selecionados])

  const mudar = (v) => {
    const ids = multiplo ? idsDe(v) : (v ? String(v) : null)
    const pessoas = (multiplo ? ids : [ids].filter(Boolean)).map((id) => equipe.find((c) => String(c.id) === id)).filter(Boolean)
    onChange?.(ids, pessoas)
  }

  return (
    <Select
      mode={multiplo ? 'multiple' : undefined}
      showSearch
      allowClear
      placeholder={placeholder || (multiplo ? 'Responsáveis' : 'Responsável')}
      notFoundContent='Ninguém encontrado'
      // enquanto a equipe carrega, não mostra ids soltos
      value={equipe.length ? selecionados : (multiplo ? [] : undefined)}
      options={opcoes}
      onChange={mudar}
      filterOption={(input, option) => collaboratorMatches({ ...option, nome: option?.label }, input)}
      style={{ width: '100%' }}
      {...props}
    />
  )
}
